import modelFieldMessages from './modelFieldMessages';

class MosserPart {
  static fields = {
    id: {
      key: 'id',
      type: 'number',
      title: modelFieldMessages.id
    },
    xCoordinate: {
      key: 'xCoordinate',
      type: 'number',
      title: modelFieldMessages.xCoordinate
    },
    yCoordinate: {
      key: 'yCoordinate',
      type: 'number',
      title: modelFieldMessages.yCoordinate
    },
    zCoordinate: {
      key: 'zCoordinate',
      type: 'number',
      title: modelFieldMessages.zCoordinate
    },
    yPos: {
      key: 'yPos',
      type: 'number',
      title: modelFieldMessages.yPos
    },
    mosserPiece: {
      key: 'yPos',
      type: 'number',
      title: modelFieldMessages.pieces
    },
    zPos: {
      key: 'zPos',
      type: 'number',
      title: modelFieldMessages.zPos
    },
    articleText: {
      key: 'articleText',
      type: 'string',
      title: modelFieldMessages.articleText
    },
    position: {
      key: 'position',
      type: 'string',
      title: modelFieldMessages.position
    },
    type: {
      key: 'type',
      type: 'number',
      title: modelFieldMessages.type
    },
    packageNumber: {
      key: 'packageNumber',
      type: 'string',
      title: modelFieldMessages.packageNumber
    },
    partNumber: {
      key: 'partNumber',
      type: 'string',
      title: modelFieldMessages.partNumber
    },
    finishedPackageId: {
      key: 'finishedPackageId',
      type: 'string',
      title: modelFieldMessages.finishedPackageId
    },
    commission: {
      key: 'commission',
      type: 'string',
      title: modelFieldMessages.commission
    },
    orderNumber: {
      key: 'orderNumber',
      type: 'string',
      title: modelFieldMessages.orderNumber
    },
    width: {
      key: 'width',
      type: 'number',
      title: modelFieldMessages.width
    },
    length: {
      key: 'length',
      type: 'number',
      title: modelFieldMessages.length
    },
    height: {
      key: 'height',
      type: 'number',
      title: modelFieldMessages.height
    },
    packageHeight: {
      key: 'packageHeight',
      type: 'number',
      title: modelFieldMessages.packageHeight
    },
    packageWidth: {
      key: 'packageWidth',
      type: 'number',
      title: modelFieldMessages.packageWidth
    },
    packageLength: {
      key: 'packageLength',
      type: 'number',
      title: modelFieldMessages.packageLength
    },
    quality: {
      key: 'quality',
      type: 'string',
      title: modelFieldMessages.quality
    },
    refinements: {
      key: 'refinements',
      type: 'string',
      title: modelFieldMessages.refinements
    },
    refinementsp: {
      key: 'refinementsp',
      type: 'string',
      title: modelFieldMessages.refinementsp
    },
    lagerColor: {
      key: 'lagerColor',
      type: 'string',
      format: {
        type: 'color'
      }
    },
    actId: {
      key: 'actId',
      type: 'number',
      title: modelFieldMessages.actId
    },
    lastSeenDate: {
      key: 'lastSeenDate',
      type: 'date',
      title: modelFieldMessages.lastSeenDate
    },
    toCnc: {
      key: 'toCNC',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.toCnc
    },
    hasSIU: {
      key: 'hasSIU',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.hasSIU
    },
    defect: {
      key: 'defect',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.defect
    },
    hasSIO: {
      key: 'hasSIO',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.hasSIO
    },
    turnAtStorage: {
      key: 'turnAtStorage',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.turning
    },
    turningInt: {
      key: 'turningInt',
      type: 'number',
      title: modelFieldMessages.turning
    },
    moveUp: {
        key: 'moveUp',
        type: 'controlAction',
        format: {
            compareField: false,
            icon: 'moveUp',
            style: { fontSize: '27px', color: 'black' }
        },
        adminRequired: false,
        modal: {
            modal: true,
            buttonText: 'moveUp',
            key: 'moveUp',
            action: 'moveUp',
            icon: 'moveUp',
            actionData: {
            target: 'control',
            source: 'ordersqueue',
            identifier: 'move-packages',
            items: 'selected',
            callType: 'POST'
            }
        },
        title: modelFieldMessages.moveUp,
        additionalParameters: { direction: 'up' }
    },
    moveDown: {
      key: 'moveDown',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'moveDown',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: false,
      modal: {
        modal: true,
        buttonText: 'moveDown',
        key: 'moveDown',
        action: 'moveDown',
        icon: 'moveDown',
        adminRequired: true,
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'move-packages',
          items: 'selected',
          additionalParameters: { direction: 'down' },
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveDown,
      additionalParameters: { direction: 'down' }
    },
  }
}

export default MosserPart;